/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
UserRank = xClass("UserRank", Event)
UserRankEvent = table([1, "FriendRank", "USERRANKEVENT.FRIENDRANK"], [1, "RankExtraInfo", "USERRANKEVENT.RANKEXTRAINFO"])
var requestOnlineRankInterval = 30 * 60 * 1000
var instance = null
UserRank.getInstance = function () {
    var self = this
    if (!instance) {
        instance = UserRank.new()
    }
    return instance
}
UserRank.prototype.ctor = function () {
    var self = this
    // self.cachedFriendRank = {
    // 	levelId = {list = {{score, profile}}, myRank, updateTime},
    // }
    self.bind(self)
    self.cachedFriendRank = table()
    self.loadingFriendRankOnline = false
    self.init()
}
UserRank.prototype.init = function () {
    var self = this
    UserLevel.getInstance().on(UserLevelEvent.WinLevel, function (event) {
        var levelType = LevelType.getLevelTypeByLevelId(event.levelId)
        if (levelType === GameLevelType.kMainLevel || levelType === GameLevelType.kHiddenLevel) {
            self.getFriendRank(event.levelId, function (list) {
                self.dispatchEvent(table(
                    [1, "name", UserRankEvent.FriendRank],
                    [1, "list", list],
                    [1, "levelId", event.levelId]
                ))
            })
        }
    })
    UserScore.getInstance().on(UserScoreEvent.UpdateScore, function (event) {
        var levelType = LevelType.getLevelTypeByLevelId(event.levelId)
        if (levelType === GameLevelType.kMainLevel) {
            self.getRankExtraInfo(event.levelId, event.oldScore.score)
        }
    })
    FriendManager.getInstance().on(FriendUpdateEvents.Update, function (event) {
        if (event.isRemoveFriend) {
            self.filterFriend(event.uid)
        }
    })
}
UserRank.prototype.getFriendRank = function (levelId, successCallback, failCallback) {
    var self = this
    if (type(self.cachedFriendRank[levelId]) === "table" && Localhost.time() - self.cachedFriendRank[levelId].updateTime < requestOnlineRankInterval) {
        if (type(successCallback) === "function") {
            var score = UserScore.getInstance().getScore(levelId)
            var profile = clone(UserManager.getInstance().getProfileRef())
            profile.setName("我")
            var ret = clone(self.cachedFriendRank[levelId].list)
            var found = false
            for (let i = 1, v = ret[1]; v; i++, v = ret[i]) {
                if (v.score.score < score.score) {
                    found = true
                    table.insert(ret, i, table([1, "score", score], [1, "profile", profile]))
                    break
                }
            }
            if (!found && score.score > 0) {
                table.insert(ret, table([1, "score", score], [1, "profile", profile]))
            }
            ret = table.filter(ret, function (v) {
                return ((v.score || table()).star || 0) > 0
            })
            successCallback(ret)
        }
    } else {
        self.updateFriendRank(levelId, successCallback, failCallback)
    }
}
var friendRankCallback = {
    success: {},
    fail: {}
}
UserRank.prototype.updateFriendRank = function (levelId, successCallback, failCallback) {
    var self = this
    if (type(successCallback) === "function") {
        friendRankCallback.success[levelId] = friendRankCallback.success[levelId] || table()
        table.insert(friendRankCallback.success[levelId], successCallback)
    }
    if (type(failCallback) === "function") {
        friendRankCallback.fail[levelId] = friendRankCallback.fail[levelId] || table()
        table.insert(friendRankCallback.fail[levelId], failCallback)
    }
    if (self.loadingFriendRankOnline) {
        return 
    }
    function onSuccess(event) {
        var scores = table()
        for (let i = 1, v = (event.data.scores || table())[1]; v; i++, v = event.data.scores[i]) {
            var score = ScoreRef.create().fromLua(v)
            if (v.uid !== UserManager.getInstance().getUserRef().uid) {
                var [_, profile] = FriendManager.getInstance().getFriendInfo(score.uid)
                profile = profile || ProfileRef.new()
                var elem = table([1, "score", score], [1, "profile", profile])
                table.insert(scores, elem)
            }
        }
        table.sort(scores, function (a, b) {
            return a.score.score > b.score.score
        })
        self.cachedFriendRank[levelId] = table([1, "list", scores], [1, "updateTime", Localhost.time()])
        self.loadingFriendRankOnline = false
        for (let i = 1, v = (friendRankCallback.success[levelId] || table())[1]; v; i++, v = friendRankCallback.success[levelId][i]) {
            self.getFriendRank(levelId, v)
        }
        friendRankCallback.success[levelId] = null
        friendRankCallback.fail[levelId] = null
    }
    function onFail(event) {
        self.loadingFriendRankOnline = false
        for (let i = 1, v = (friendRankCallback.fail[levelId] || table())[1]; v; i++, v = friendRankCallback.fail[levelId][i]) {
            v(event)
        }
        friendRankCallback.success[levelId] = null
        friendRankCallback.fail[levelId] = null
    }
    self.loadingFriendRankOnline = true
    var http = GetLevelTopHttp.new(false)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.load(levelId)
}
UserRank.prototype.filterFriend = function (uid) {
    var self = this
    for (let k in self.cachedFriendRank) {
        var v = self.cachedFriendRank[k]
        for (let l in v.list) {
            var w = v.list[l]
            if (tostring((w.score || table()).uid) === tostring(uid)) {
                table.remove(v.list, l)
                break
            }
        }
    }
}
UserRank.prototype.getRankExtraInfo = function (levelId, oldScore) {
    var self = this
    function onSuccess(event) {
        self.dispatchEvent(table(
            [1, "name", UserRankEvent.RankExtraInfo],
            [1, "levelId", levelId],
            [1, "share", event.data.share],
            [1, "progress", event.data.progress],
            [1, "latestVer", event.data.latestVer],
            [1, "rankPosition", event.data.rankPosition]
        ))
    }
    function onFail(event) {
        console.log("@@@@ extra stage error")
    }

    var maxLevel = MetaManager.getInstance().getMaxNormalLevelByLevelArea()
    var http = RankExtraInfoHttp.new(false)
    http.addEventListener(Events.kComplete, onSuccess)
    http.addEventListener(Events.kError, onFail)
    http.load(levelId, maxLevel, oldScore)
}
